<div class="bsg-input-wrapper" id="searchbar">
  <div class="col-md-12 col-sm-12 col-lg-6">
    <span [ngbTooltip]="(disabled ? 'searchbar.nichtRegistriert' : '') | translate" placement="bottom">
      <div class="input-group">
        <div class="form-control-component">
          <input
            (selectItem)="onSelected($event)"
            [(ngModel)]="value"
            [disabled]="disabled"
            [inputFormatter]="inputFormatter"
            [ngbTypeahead]="search"
            [placeholder]="'searchbar.placeholderText' | translate"
            [resultFormatter]="resultFormatter"
            class="form-control"
            type="text" />
          @if (showNoResultText) {
            <div class="dropdown-menu show dropdown-message">
              <button (click)="onClear()" class="dropdown-item">{{ "searchbar.noResults" | translate }}</button>
            </div>
          }
        </div>
        <div class="input-group-text bg-white border-start-0"><i class="fa fa-search" style="color: grey"></i></div>
        <button (click)="onClear()" [disabled]="disabled" class="btn btn-white" tabindex="-1" type="button">
          <span class="fas fa-times"></span>
        </button>
      </div>
    </span>
  </div>
</div>
